import { createSelector } from "reselect";

const getFiltrosAplicados = state => state.confirmadas.filtrosAplicados;
const getInscripciones = state => state.confirmadas.inscripcionesDelColegio;

const getDatosFiltrados = createSelector(
  [getFiltrosAplicados, getInscripciones],
  (filtros, inscripciones) =>
    filtros === null
      ? inscripciones
      : inscripciones.filter(
          ({ edad }) => edad >= filtros.desde && edad <= filtros.hasta
        )
);

export { getDatosFiltrados };



// WEBPACK FOOTER //
// ./src/ducks/confirmadas/selectores.js